import { render, staticRenderFns } from "./TabCourses.vue?vue&type=template&id=0b3f7ea1"
import script from "./TabCourses.vue?vue&type=script&lang=js"
export * from "./TabCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports